import type {AxiosResponse} from "axios";

import CoreApi from "@/src/modules/core/api";

import type {
  CompleteClaimRequest,
  ResidentClaimApiResponse,
  ResidentClaimCompleteData,
  ResidentClaimProfileData,
  ResidentClaimProfileRequest,
  ResidentClaimStartData,
  ResidentClaimVerifyData,
  StartClaimRequest,
} from "../types";

class ResidentClaimApi extends CoreApi {
  startClaim(
    body: StartClaimRequest,
  ): Promise<AxiosResponse<ResidentClaimApiResponse<ResidentClaimStartData>>> {
    return this.post("resident-claim/start", body);
  }

  completeClaim(
    body: CompleteClaimRequest,
  ): Promise<AxiosResponse<ResidentClaimApiResponse<ResidentClaimCompleteData>>> {
    return this.post("resident-claim/complete", body);
  }

  verifyClaim(
    token: string,
  ): Promise<AxiosResponse<ResidentClaimApiResponse<ResidentClaimVerifyData>>> {
    return this.get(`resident-claim/verify/${encodeURIComponent(token)}`);
  }

  completeProfile(
    body: ResidentClaimProfileRequest,
  ): Promise<AxiosResponse<ResidentClaimApiResponse<ResidentClaimProfileData>>> {
    return this.post("resident-claim/profile", body);
  }
}

export const residentClaimApi = new ResidentClaimApi();
